export const API_PATH_PREFIX = '/bff';
